import React, { useEffect, useState } from "react";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import LoadMask from "Utils/LoadMask/LoadMask";
import { DetalleCierreApi } from "../api/DetalleCierreApi";
import { CierreInventarioTable } from "../../components/CierreInventarioTable";
import { ResumenFisicoPadresPT } from "../../components/ResumenFisicoPadresPT";
import { ReajustesInventarioTable } from "../../../../../components/ReajustesInventarioTable";
import { getErrorFromResponse } from "../../../../../../../../../utility/utils";

export const DetalleCierreContenido = ({ cierreId, regresar }) => {
    const { getCierre, getReajustes, descargarCierreExcel, cargando } =
        DetalleCierreApi();

    const [cierre, setCierre] = useState(null);
    const [reajustes, setReajustes] = useState([]);

    const GetCierre = async () => {
        try {
            const response = await getCierre(cierreId);
            setCierre(response);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener el cierre de inventario",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
            setCierre(null);
        }
    };

    const GetReajustes = async () => {
        try {
            const response = await getReajustes(cierreId);
            setReajustes(response.results);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener los reajustes del cierre",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
            setReajustes([]);
        }
    };

    const DescargarExcel = async () => {
        try {
            await descargarCierreExcel(cierre);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al exportar el cierre de inventario",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    useEffect(() => {
        GetCierre();
        GetReajustes();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cierreId]);

    return (
        <LoadMask loading={cargando} blur>
            {cierre && (
                <React.Fragment>
                    <div className="formulario-fields-row align-items-end">
                        <div className="formulario-field">
                            <label className="text-nowrap">No. de cierre</label>
                            <input
                                type="text"
                                className="form-control disabled-input"
                                value={cierre.numero}
                                disabled
                            />
                        </div>
                        <div className="formulario-field">
                            <label className="text-nowrap">Responsable</label>
                            <input
                                type="text"
                                className="form-control disabled-input"
                                value={cierre.usuario_nombre || "No definido"}
                                disabled
                            />
                        </div>
                        <div className="formulario-field">
                            <label className="text-nowrap">
                                Fecha y hora de corte
                            </label>
                            <input
                                type="text"
                                className="form-control disabled-input"
                                value={moment(cierre.fecha_corte).format(
                                    "DD/MM/YYYY HH:mm",
                                )}
                                disabled
                            />
                        </div>
                    </div>

                    {cierre.periodo_inicial && (
                        <small className="d-block mt-2 mb-3 help-text">
                            Este cierre abarcó los movimientos desde el{" "}
                            {moment(cierre.periodo_inicial).format(
                                "DD/MM/YYYY HH:mm",
                            )}{" "}
                            hasta el{" "}
                            {moment(cierre.fecha_corte).format(
                                "DD/MM/YYYY HH:mm",
                            )}
                            .
                        </small>
                    )}

                    <ResumenFisicoPadresPT
                        resumen={cierre.resumen_fisico_por_padre}
                    />

                    <CierreInventarioTable
                        titulo="Pacas de pallets"
                        campo="pacas"
                        filas={cierre.detalles_pacas}
                        cierreId={cierre.id}
                    />

                    <CierreInventarioTable
                        titulo="Sobrante"
                        filas={cierre.detalles_sobrante}
                    />

                    {/* sin reajustes el físico es igual al teórico, así que no
                    hay diferencia que explicar */}
                    {reajustes.length > 0 && (
                        <div className="cierre-inventario__tabla">
                            <h6 className="cierre-inventario__tabla-titulo">
                                Reajustes que originaron la diferencia
                            </h6>
                            <ReajustesInventarioTable
                                reajustes={reajustes}
                                mostrarCierre={false}
                            />
                        </div>
                    )}
                </React.Fragment>
            )}

            <div className="d-flex justify-content-center mt-3 gap-1rem">
                <button className="btn btn-outline-dark" onClick={regresar}>
                    Regresar
                </button>

                {cierre && (
                    <button
                        className="btn btn-secondary"
                        onClick={DescargarExcel}
                        disabled={cargando}
                    >
                        Exportar a Excel
                    </button>
                )}
            </div>
        </LoadMask>
    );
};
